var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopBar',{attrs:{"influencer":_vm.influencer}}),_c('Groups')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }